// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qerTx","inputsContainer":"styles_inputsContainer__KalmO","passwordContainer":"styles_passwordContainer__6zU0D","link":"styles_link__CbQB8"};